import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"

export const FlexWrapper = styled.div`
  display: flex;
  margin: 20px 0;
`

export const ImagePreview = styled.img`
  width: 100%;
  max-height: 100%;
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin-right: 20px;
  padding: 4px;
  border: 1px solid ${({theme}) => theme.colors.greys.grey20};
  border-radius: 5px;
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const DeleteButton = styled(Button)`
  max-width: 100px;
`

export const StyledIcon = styled(Icon)`
  margin-right: 5px;
`
